
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from "../../../_services/alert.service";
import { environment } from "../../../../environments/environment";
import { ApiHttpService } from "../../../_services/api-http.service";
import {
  ColDef,
  Column,
  ColumnApi,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';
import { MerchantFilter, MerchantService } from '../merchants/merchant-master/merchant.service';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
//const { API_URL } = environment;

const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;
// public defaultColDef: ColDef|any = {
//   flex: 1,
//   minWidth: 150,
//   filter: true,
//   resizable: true,
//   sortable:true,
  
// }

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
   template: `
    <div [innerHTML]="htmlContent"></div>
    <button (click)="loadHtmlFile()">Load HTML File</button>
  `
})


export class DocumentsComponent implements OnInit {

  kycUploadModalConfig: ModalConfig;
  kycViewModalConfig: ModalConfig;
  kycFileSrc: any;
  orvreport: FormGroup;
  Resultdata: any;
  merchantId:any;
  mindatadis: boolean = true;
  loading: boolean = false;
  htmlContent: string;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public page: number = 1
  currentPage: number = 1;
  public rowData:any=[];
  collectionSize: number = 0;
  collectiondata: number=0
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  tableSelectedColumn: ColDef[] = [];
  maxSize:number;
  ellipses: boolean= true;
  modalConfigBlocked: ModalConfig;


  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  
  
  constructor(private  formBuilder: FormBuilder, private apiHttpService: ApiHttpService,private alertService: AlertService,private merchantService: MerchantService ) {
    this.orvreport = formBuilder.group({
      merchantId: [null, Validators.required],
      fileupload:["",Validators.required],
    })
  }
  
  ngOnInit(): void {
    const self = this;
    this. mindatadis = true;

    this.kycViewModalConfig = {
      modalTitle: "Merchant Status",
      modalSize: 'xl',
      fullscreen: true,
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      },
      onClose(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      },
      onTopClose(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      },
      onDismiss(): Promise<boolean> | boolean {
        self.kycFileSrc = null;
        return true
      }
    }
    this.modalConfigBlocked = {
      modalTitle: "Document",
      modalSize: 'xl',
   
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    const filter: MerchantFilter = {}
    filter.startDate = "";
    filter.endDate = "";
    this.merchantService.getMerchantList("","","","","","","",filter,"ALL",0).subscribe((response)=>{
      console.log(response);
      this.Resultdata = response.content;
    })

    
    // this.Resultdata = [{"MerchantId":"2420110030706089","merchant_name":"Siddhant Pathak"}];
  }
  public columnDefs: ColDef[] = [
    {field: 'id', tooltipField: 'id', headerName: 'ID',  cellRenderer: 'agGroupCellRenderer',resizable: true,},
    {field: 'merchantId',tooltipField: 'merchantId', headerName: 'Merchant ID',resizable: true},
    {field: 'docType' ,tooltipField: 'docType', headerName: 'Doc Type',resizable: true},  
  ];



  hmnlpage:any;
   Merchantdata:any;
  onSubmit(formvalue: any): void {
    this.loading = true
    this. mindatadis = true;
     this.Merchantdata=formvalue.merchantId;
     //kyc/merge/{merchantId}
debugger
    this.apiHttpService.post(`${API_URL}/kyc/merge/${this.Merchantdata}`, null).subscribe((data) => (
     this.downloadPdf(data,this.Merchantdata)
    ));
  }
  downloadPdf(data:any,Merchant:any) {
  //  alert("data==="+data+"  ,   Merchant======"+Merchant)
if(data){
    const linkSource =
    'data:application/octet-stream;base64,' +data.text;
    const downloadLink = document.createElement('a');
    const fileName = 'Merchant_'+Merchant+'.pdf';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    this.loading = false
  }else{
    this. mindatadis = false;
    this.loading = false
  }
  }
  
  downloadAutomated(){
    
    debugger
  //  let   mid=20230001;
    this.apiHttpService.post(`${API_URL}/mergeBasicReport/${this.merchantid}`, null)
    .subscribe((data) => (
     this.downloadPdfauto(data,this.merchantid)
    ));
  
  }

  downloadPdfauto(data:any,Merchant:any) {
 // alert("JSON DATA"+JSON.stringify(data))
 // alert("data"+data)
    if(data){
        const linkSource =
        'data:application/octet-stream;base64,' +data.text;
        const downloadLink = document.createElement('a');
        const fileName = 'AVR_'+Merchant+'.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.loading = false
      }else{
        this. mindatadis = false;
        this.loading = false
      }
      }
  downloadManual(){
   let   mid=2308829032;
    this.apiHttpService
    .post(
      `${API_URL}/merge/${this.merchantid}`, null
      )
    .subscribe((data) => (
     this.downloadPdfmanu(data,this.merchantid)
    ));
  }
  downloadPdfmanu(data:any,Merchant:any) {
    if(data){
        const linkSource =
        'data:application/octet-stream;base64,' +data.text;
        const downloadLink = document.createElement('a');
        const fileName = 'MVR_'+Merchant+'.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.loading = false
      }else{
        this. mindatadis = false;
        this.loading = false
      }
      }

  merchantid:any;
  disablebtn:boolean=true;
  showhtml:boolean=false
  onSelectMerchant(event:any){ 
    if(event==undefined){
      this.showhtml=false  
      this.disablebtn=true;     
    }
    else{    
      this.disablebtn=false;  
      this.merchantid=event;
      this.showhtml=true
      this.getBtnFlag(event);
     this.getDocument()
    }
  }
  
  btnflag:any;
  btnpan:any
  btnvaluepan:any
  btnvalue:any;
  btnvalue1:any;
  btngst:any
  btnvaluegstn:any
  btnmca:any
  btnvaluemca:any
  btnaccount:any
  btnvalueaccount:any
  btnweb:any
  btnvalueweb:any
  btncibil:any
  btnvaluecibil:any
  btnfiu:any
  btnvaluefiu:any
  btnpep:any
  btnvaluepep:any
  btnnmas:any
  btnvaluenmas:any
  btnaml:any
  btnvalueaml:any
  osvbtn:any
  osvvalue:any
  irabtn:any
  iravalue:any
  mcmTncBtn:any
  mcmTncValue:any
  mcmMrpBtn:any
  mcmMrpValue:any
  mcmMGPbtn:any
  mcmMGPValue:any
  mcmAOCbtn:any
  mcmAOCValue:any
  mcmCOCBtn:any
  mcmCOCValue:any
  mcmVaptbtn:any
  mcmVaptValue:any



     
//   "panVerification": try,
//   "gstn": false,
//   "mca": false,
//   "accountVerification": false,
//   "webCrawler": false,
//   "cibilAndSmr": false,
//   "pepSanction": false,
//   "fiuIntegration": false,
//   "nmasVmtsMatch": false,
//   "amlVerify": false,
//   "negativeData": null,
//   "verifiedDate": null

getBtnFlag(merchantidd:any){
  this.apiHttpService.post(`${API_URL}/verification/details/${merchantidd}`, null).subscribe((data) => {    
    this.btnflag=JSON.stringify(data);   
    console.log("verification details"+JSON.stringify(data))    
    let val=false;
    if(data.panVerification){
      this.btnpan='btn btn-success btn-sm'; 
      this.btnvaluepan="Document Uploaded"
    }if(data.panVerification==false){
      this.btnpan='btn btn-danger btn-sm'; 
      this.btnvaluepan="Document Not Uploaded"
    }
    if( data.gstn){
      this.btngst='btn btn-success btn-sm'; 
      this.btnvaluegstn="Document Uploaded"
    }
    if( data.gstn==false){
      this.btngst='btn btn-danger btn-sm'; 
      this.btnvaluegstn="Document Not Uploaded"
    }
    if(data.mca){
      this.btnmca='btn btn-success btn-sm'; 
      this.btnvaluemca="Document Uploaded"
    }
    if(data.mca==false){
      this.btnmca='btn btn-danger btn-sm'; 
      this.btnvaluemca="Document Not Uploaded"
    }
    if(data.accountVerification){
      this.btnaccount='btn btn-success btn-sm'; 
      this.btnvalueaccount="Document Uploaded"
    }
    if(data.accountVerification==false){
      this.btnaccount='btn btn-danger btn-sm'; 
      this.btnvalueaccount="Document Not Uploaded"
    }
    if(data.webCrawler){
      this.btnweb='btn btn-success btn-sm'; 
      this.btnvalueweb="Document Uploaded"
    }
    if(data.webCrawler==false){
      this.btnweb='btn btn-danger btn-sm'; 
      this.btnvalueweb="Document Not Uploaded"
    }
    if(data.cibilAndSmr){
      this.btncibil='btn btn-success btn-sm'; 
      this.btnvaluecibil="Document Uploaded"
    }
    if(data.pepSanction){
      this.btnpep='btn btn-success btn-sm'; 
      this.btnvaluepep="Document Uploaded"
    }
    if(data.pepSanction==false){
      this.btnpep='btn btn-danger btn-sm'; 
      this.btnvaluepep="Document Not Uploaded"
    }
    if( data.fiuIntegration){
      this.btnfiu='btn btn-success btn-sm'; 
      this.btnvaluefiu="Document Uploaded"
    }
    if( data.fiuIntegration){
      this.btnfiu='btn btn-success btn-sm'; 
      this.btnvaluefiu="Document Uploaded"
    }
    if(data.nmasVmtsMatch){
      this.btnnmas='btn btn-success btn-sm'; 
      this.btnvaluenmas="Document Uploaded"
    }
    if(data.nmasVmtsMatch){
      this.btnnmas='btn btn-success btn-sm'; 
      this.btnvaluenmas="Document Uploaded"
    }
    if(data.amlVerify){
      this.btnaml='btn btn-success btn-sm'; 
      this.btnvalueaml="Document Uploaded"
    }
    if(data.amlVerify){
      this.btnaml='btn btn-success btn-sm'; 
      this.btnvalueaml="Document Uploaded"
    }
    if(data.osv){
      this.osvbtn='btn btn-success btn-sm'; 
      this.osvvalue="Document Uploaded"
    }
    if(data.osv==false){
      this.osvbtn='btn btn-danger btn-sm'; 
      this.osvvalue="Document Not Uploaded"
    }

    if(data.ira){
      this.irabtn='btn btn-success btn-sm'; 
      this.iravalue="Document Uploaded"
    }
    if(data.ira==false){
      this.irabtn='btn btn-danger btn-sm'; 
      this.iravalue="Document Not Uploaded"
    }
    if(data.mcm_TNC){
      this.mcmTncBtn='btn btn-success btn-sm'; 
      this.mcmTncValue="Document Uploaded"
    }
    if(data.mcm_TNC==false){
      this.mcmTncBtn='btn btn-danger btn-sm'; 
      this.mcmTncValue="Document Not Uploaded"
    }
    
    if(data.mcm_MRP){
      this.mcmMrpBtn='btn btn-success btn-sm'; 
      this.mcmMrpValue="Document Uploaded"
    }
    
    if(data.mcm_MRP==false){
      this.mcmMrpBtn='btn btn-danger btn-sm'; 
      this.mcmMrpValue="Document Not Uploaded"
    }
    
    if(data.mcm_MGP){
      this.mcmMGPbtn='btn btn-success btn-sm'; 
      this.mcmMGPValue="Document Uploaded"
    }
    
    if(data.mcm_MGP==false){
      this.mcmMGPbtn='btn btn-danger btn-sm'; 
      this.mcmMGPValue="Document Not Uploaded"
    }
    if(data.mcm_AOC){
      this.mcmAOCbtn='btn btn-success btn-sm'; 
      this.mcmAOCValue="Document Uploaded"
    }
    
    if(data.mcm_AOC==false){
      this.mcmAOCbtn='btn btn-danger btn-sm'; 
      this.mcmAOCValue="Document Not Uploaded"
    }
    if(data.mcm_COC){
      this.mcmCOCBtn='btn btn-success btn-sm'; 
      this.mcmCOCValue="Document Uploaded"
    }
    
    if(data.mcm_COC==false){
      this.mcmCOCBtn='btn btn-danger btn-sm'; 
      this.mcmCOCValue="Document Not Uploaded"
    }
    if(data.mcm_VAP){
      this.mcmVaptbtn='btn btn-success btn-sm'; 
      this.mcmVaptValue="Document Uploaded"
    }
    
    if(data.mcm_VAP==false){
      this.mcmVaptbtn='btn btn-danger btn-sm'; 
      this.mcmVaptValue="Document Not Uploaded"
    }
  });
}
docName:any
docpath:any
docType:any
list:any
listboolean:boolean=false;
hidehtml:boolean=true;
getDocument(){
 // alert("ts")
this.merchantService.getDocumentList(this.merchantid,this.pageSize,this.page).subscribe((data)=>{
  // this.merchantService.getDocumentList('054c5a27-2f86-445f-9dce-43f5b50e6e28',this.pageSize,this.page).subscribe((data)=>{


console.log("docment list ===="+JSON.stringify(data));
  this.rowData = data?.content  || data || [],
  
 
  // this.docpath=this.rowData[0].docpath.substr(1);
  this.docpath=this.rowData[0].docpath;

this.docType=this.rowData[0].docType

if(this.docpath==''||this.docType==''){
   
  this.hidehtml=false;

}
else{
  this.hidehtml=true;
}
 
  this.collectiondata = data[0]?.totalRecord||0 
  this.collectionSize=this.collectiondata
  if(this.rowData.length <=0){
    this.alertService.errorAlertWithMessage("No records present");
    return }

})

  
}
// $scope.imageAddress='resources/img/new.png';

onPaginationChange(param: PaginationChangedEvent | any) {
  this.page=param;
  debugger
  this.gridApi.applyTransaction({remove: this.rowData})
   this.gridApi.showLoadingOverlay();
 
 
  this.getDocument();
 
}
onPageSizeChanges($event: Event) {
  debugger
  this.gridApi.paginationSetPageSize(this.pageSize)
  this.gridApi.applyTransaction({remove: this.rowData})
  this.gridApi.showLoadingOverlay();   
  this.getDocument();
}

// onGridReady(params: GridReadyEvent<IMerchantData>) {
  onGridReady(params: GridReadyEvent) {
  debugger
  this.gridApi = params.api;
  this.gridColumnApi = params.columnApi;
  this.gridApi.getFilterInstance('age', (filterParam) => {
  })
  this.gridApi.showLoadingOverlay();
  // this.gridApi.setQuickFilter(this.globalSearch);
  const allColumnIds: (string | Column)[] = [];
  params?.columnApi?.getColumns()?.forEach((column) => {
    allColumnIds.push(column.getId());
  });
  params?.columnApi?.autoSizeColumns(allColumnIds, false);
  this.getDocument();

}
image:any;
pdfvalue:boolean=false;

loadPDFFile(url: string): Promise<any> {
  console.log("url:::: "+ url);
  return new Promise((resolve, reject) => {
    this.apiHttpService.post(url, null).subscribe(
      (data) => {
 
        resolve(data.text);
      },
      (error) => {
        reject(error);
      }
    );
  });
}


async onViewBtnClick(MerchantId:any,docpath:any){

  
 
  var data=await this.loadPDFFile(`${API_URL}/getFile/${MerchantId}?location=${docpath}`);  
//   console.log("Data Loaded " + data==null)
//  console.log("stringify(data.text)==="+JSON.stringify(data))
let image_path = docpath;
  
//alert(image_path)
let file_extension = image_path.slice(-3);
  
if(file_extension==="pdf"){  
    this.pdfvalue = true;
    this.image="data:application/pdf;base64,"+data;
     console.log("inside the is pdf block:::");
    // console.log(this.image);

  
}
else{
  this.pdfvalue = false;
  this.image="data:image/png;base64,"+data;
   console.log("inside the is png block:::");
   
} 
  
this.modalblockedComponent.open(); 


 //this.image="data:application/pdf;base64,"+data.text;
 
}

 
   async loadHtmlFile() {
    debugger
    try {
      const filePath = '../../../../assets/images/merchant_summary_table.html'; // Replace with your file's path
      this.htmlContent = await this.merchantService.getHtmlFile(filePath);
    } catch (error) {
      console.error('Error loading HTML file:', error);
    }
  }




}